import React from "react";
import { Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { SidebarData } from "../../components/Sidebar/SidebarData";
import HCDRouter from "./HCDRouter";
import * as MdIcon from "react-icons/md";
import { AreaTitle } from "../../components/AreaTitle/AreaTitle";
import { BasicCard } from "../../components/BasicCard/BasicCard";

const HistoriaClinicaDigital = () => {
  const datahc = SidebarData.perfilDelPaciente.find((d) => d.id === 6);
  const routes = datahc.options;

  return (
    <BasicCard
      header={
        <AreaTitle
          addClass="p-3"
          title="Historia clínica"
          icon={<MdIcon.MdFolderShared />}
        />
      }
    >
      <Row>
        <Col className="switch-container p-3">
          {routes.map((route) => {
            return (
              <NavLink
                key={route.path}
                className="me-2"
                activeClassName="active-switch"
                to={route.path}
              >
                {route.title}
              </NavLink>
            );
          })}
        </Col>
      </Row>
      <Row>
        <Col className="switch-container__hc">
          <HCDRouter />
        </Col>
      </Row>
    </BasicCard>
  );
};

export default HistoriaClinicaDigital;
